import { type AppRouter } from '../../server/appRouter';
// import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';

export const trpc = createTRPCReact<AppRouter>();
//   {
//   links: [
//     httpBatchLink({
//       fetch(url, options) {
//         return fetch(url, {
//           ...options,
//           credentials: 'include',
//         });
//       },
//       url: import.meta.env.VITE_API_BASE_URL,
//     }),
//   ],
// });
